import { Helmet } from 'react-helmet-async'
import { SeoHead } from '../seo/SeoHead'
import { siteConfig } from '../../config/site'

/** Static-host fallback; production serves an HTTP 301 from _redirects. */
export function WorkRedirect() {
  return <>
    <SeoHead pathname={siteConfig.workIndexUrl} kind="work" />
    <Helmet><meta httpEquiv="refresh" content={`0;url=${siteConfig.workIndexUrl}`} /></Helmet>
    <p><a href={siteConfig.workIndexUrl}>Go to Work</a></p>
  </>
}
